import { breakpoints } from '../constants/breakpoits.constants'

export const scrollToTop = () => setTimeout(() => window.scrollTo(0, 0))

export const isMobile = () => window.innerWidth < breakpoints.MOBILE